<template>
  <div class="catalog-lock-notice">
    <BaseIcon name="information-circle" :size="16" />
    <div>
      <strong>{{ title }}</strong>
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@/components/partials/BaseIcon.vue';

  export default {
    name: 'CatalogLockNotice',
    components: { BaseIcon },
    props: {
      title: { type: String, default: 'Uit de catalogus van de leverancier' },
      text: {
        type: String,
        default:
          'Opties, prijzen en beperkingen komen uit de prijslijst en worden bij een nieuwe versie bijgewerkt. Welke opties en keuzes je voert, je afspraak en je eigen regels stel je in op de tab Basis en Regels.',
      },
    },
  };
</script>

<style scoped lang="scss">
  .catalog-lock-notice {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--amber-200);
    background: var(--amber-50);
    border-radius: 0.5rem;
    color: var(--amber-900);
    @include fontSize('sm');

    p {
      margin: 0.15rem 0 0;
      color: var(--amber-800);
    }
  }
</style>
